define('commons/simple-pagination',['jquery'], function($) {
	$.fn.simplePagination = function(options) {
		var $this = $(this);
		
        var settings = $.extend({
        	autoload: false,
            nextPageSelector: '.paginator-link-next',
            previousPageSelector: '.paginator-link-previous',
            onRefresh: function() {}
        }, options);
        
        var currentPageParam;
        var bind;
        
        var load = function(pageParam) {
        	currentPageParam = pageParam;
        	
        	var url = settings.url;
        	
        	if (pageParam) {
        		url += url.indexOf('?') < 0 ? ('?' + pageParam) : ('&' + pageParam);
        	}
        	
            $.get(url, function(data) {
			    $this.html(data);
			    bind();
			    settings.onRefresh();
			});
        };
        
        var refresh = function() {
        	load(currentPageParam);
        };
        
        var changePage = function() {
        	var pageParam = $(this).data('params');
        	load(pageParam);
        };
        
        bind = function() {
        	$this.find(settings.nextPageSelector).click(changePage);
        	$this.find(settings.previousPageSelector).click(changePage);
        };
        
        if (settings.autoload) {
        	load();
        } else {
        	bind();
        }
        
		return {
			refresh: refresh
		};
	};
});
